import script from "./CalendarCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarCreate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__